import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { setSideBarToggle } from '../action/SideBarAction';

const ArrumandoCasaItem = (props) => {
	const { setSideBarToggle } = props;
	const [show, setShow] = useState('');

	return (
		<div className='tour-passo-arrumando'>
			{/* <!-- Heading --> */}
			{/* <div className='sidebar-heading'>Arrumando a casa</div> */}

			<li className='nav-item'>
				<a
					className={`nav-link collapsed`}
					href='#!'
					data-toggle='collapse'
					data-target='#collapseContas'
					aria-expanded='true'
					aria-controls='collapseContas'
					onClick={() => setShow('')}
				>
					<i className='fas fa-fw fa-wallet'></i>
					<span>Arrumando a casa</span>
				</a>
				<div
					id='collapseContas'
					className={`collapse ${show}`}
					aria-labelledby='headingTwo'
					data-parent='#accordionSidebar'
				>
					<div className='bg-white py-2 collapse-inner rounded'>
						{/* <h6 className='collapse-header'>Arrume a Casa</h6> */}
						<Link
							className='collapse-item'
							to='/dashboard/casa/meus-lancamentos'
							onClick={() => {
								setShow('hide');
								setSideBarToggle('toggled');
							}}
						>
							Meus lançamentos
						</Link>
						<Link
							className='collapse-item'
							to='/dashboard/casa/como-esta-dinheiro'
							onClick={() => {
								setShow('hide');
								setSideBarToggle('toggled');
							}}
						>
							Como está meu dinheiro?
						</Link>
						<Link
							className='collapse-item'
							to='/dashboard/casa/meus-graficos'
							onClick={() => {
								setShow('hide');
								setSideBarToggle('toggled');
							}}
						>
							Meus gráficos
						</Link>
					</div>
				</div>
			</li>
		</div>
	);
};

export default connect(null, { setSideBarToggle })(ArrumandoCasaItem);
